import { render, staticRenderFns } from "./AssignTeamWorkspace.vue?vue&type=template&id=41c4a71a&scoped=true"
import script from "./AssignTeamWorkspace.vue?vue&type=script&lang=js"
export * from "./AssignTeamWorkspace.vue?vue&type=script&lang=js"
import style0 from "./AssignTeamWorkspace.vue?vue&type=style&index=0&id=41c4a71a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c4a71a",
  null
  
)

export default component.exports